// @ts-strict
/**
 * Created by claudenbach on 1/30/2017.
 */

import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { escape } from 'lodash-es';

export const lmButtonFormatter = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  if (columnDef.id === 'formOverlayTriggerButton' && !dataView.redirectAction) {
    if (lmFormatterService.isTotalRow(dataView))
      return '';
    if (dataView.isTreeMoreLink)
      return '';
    return Soho.Formatters.Drilldown(row, cell, value, columnDef, dataView, dataGrid);
  }

  columnDef.contentWidth = '100%';

  columnDef.cssClass = 'lm-button-formatter-container';

  if (dataView.isTreeMoreLink) {
    return lmFormatterService.getMoreLink(cell, dataView);
  }

  if (columnDef.displayField.visibility) {
    if (!lmFormatterService.isConditionValid(columnDef.displayField.visibility, dataView)) {
      return '';
    }
  }

  const displayValue = columnDef.displayField.title ? lmFormatUtilService.formatMessageRule(columnDef.displayField.title, dataView) : '';
  const formatButtonText = lmFormatterService.formatButtonText(row, cell, escape(displayValue), columnDef, dataView, dataGrid);

  if (lmFormatterService.expandableRowCardView() && columnDef.columnNumber === 0 && !lmFormatterService.isTotalRow(dataView)) {
    return Soho.Formatters.Expander(row, cell, formatButtonText, columnDef, dataView, dataGrid);
  }

  return formatButtonText;
};
